import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontWeight,
  JustifyContent,
  Link,
  Text,
} from '@gousto-internal/citrus-react'

import { CarouselTrack } from './CarouselTrack'
import { RecipeCarouselCard } from './RecipeCarouselCard'

export type RecipeCarouselRecipe = {
  id: string
  title: string
  imageUrl: string
  imageAlt: string
  cookTimeMins?: number
  kcal?: number
  dietaryClaims?: { slug: string }[]
  ariaLabel?: string
  onClick: () => void
}

export type RecipeCarouselHeaderAction = {
  label: string
  href?: string
  onClick: () => void
}

export type RecipeCarouselProps = {
  title: string
  subtitle?: string
  headerAction?: RecipeCarouselHeaderAction
  recipes: RecipeCarouselRecipe[]
  ariaLabel?: string
}

const HeaderAction = ({ action }: { action: RecipeCarouselHeaderAction }) => (
  <Box flexShrink={0} style={{ whiteSpace: 'nowrap' }}>
    {action.href ? (
      <Link href={action.href} onClick={action.onClick}>
        {action.label}
      </Link>
    ) : (
      <Link onClick={action.onClick}>{action.label}</Link>
    )}
  </Box>
)

export const RecipeCarousel = ({
  title,
  subtitle,
  headerAction,
  recipes,
  ariaLabel,
}: RecipeCarouselProps) => {
  return (
    <Box position={DisplayPosition.Relative}>
      <Box
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.SpaceBetween}
        gap={3}
        paddingBottom={2}
      >
        <Box display={Display.Flex} flexDirection={FlexDirection.Column} minWidth="0">
          <Body2 color={Color.ColdGrey_900} fontWeight={FontWeight.Bold} size={[5, 9]}>
            {title}
          </Body2>
          {subtitle ? (
            <Text color={Color.ColdGrey_600} size={1}>
              {subtitle}
            </Text>
          ) : null}
        </Box>
        {headerAction ? <HeaderAction action={headerAction} /> : null}
      </Box>

      <CarouselTrack
        ariaLabel={ariaLabel ?? title}
        items={recipes}
        renderItem={(recipe) => <RecipeCarouselCard recipe={recipe} />}
      />
    </Box>
  )
}
